/* The Playground Guide — three tabs:
 *   Concepts            — the building blocks, bottom-up + what you can build.
 *   Interactive learning — Screen (Components + Surfaces) + Workflows playgrounds.
 *   Complete Guide      — the entire BeX App abstraction reference, rendered
 *                         as-is (its own self-contained page) inside an iframe. */
import React, { useState } from "react";
import { BookOpen, PlayCircle, Library } from "lucide-react";
import { ConceptsSection } from "./sections/ConceptsSection";
import { InteractiveSection } from "./sections/InteractiveSection";
import { CompleteGuideSection } from "./sections/CompleteGuideSection";
import "./guide.css";

interface SectionDef {
  id: string;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
  render: () => React.ReactNode;
}

const SECTIONS: SectionDef[] = [
  { id: "concepts", label: "Concepts", icon: BookOpen, render: () => <ConceptsSection /> },
  { id: "interactive", label: "Interactive learning", icon: PlayCircle, render: () => <InteractiveSection /> },
  { id: "complete", label: "Complete Guide", icon: Library, render: () => <CompleteGuideSection /> },
];

export default function GuidePage() {
  const [active, setActive] = useState("concepts");
  const section = SECTIONS.find((s) => s.id === active) ?? SECTIONS[0];

  return (
    <div className="gd-root" data-theme="appstudio">
      <div className="gd-tabs">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          return (
            <button
              key={s.id}
              type="button"
              className={"gd-tab" + (active === s.id ? " active" : "")}
              onClick={() => setActive(s.id)}
            >
              <Icon size={15} />
              {s.label}
            </button>
          );
        })}
      </div>
      <div className="gd-body" key={active}>{section.render()}</div>
    </div>
  );
}
